

import React from 'react';

import { 
    DashboardLayout, GeneralTable
} from "components";

import { loggingColumns } from "./data";
import { func_validation, getTotalCountFromHeader } from "functions";

import 'assets/scss/distributorPortal/modules/logging.scss';



export function LoggingPresentation(props) {
    // Props
    const { 
        getLogs_requesting, getLogs_status, 
        logList, logListHeaders,
    } = props;

    let logList_formatted = [];
    if (func_validation.isArrayNotEmpty(logList)) {
        logList_formatted = logList.map((logDetails) => {
            let obj_formatted = logDetails;
            let msgDetails = func_validation.getObjectPropertyValue(logDetails, "MessageDetail");
            if (func_validation.isStringNotEmpty(msgDetails) || true) {
                // obj_formatted["subRows"] = [{ Message: msgDetails }];
                obj_formatted["subRows"] = [{ Message: "Create license for Comid = maxis, CompanyName = maxis, PackakgeId = 58, LicenseCreated = 627a2c0f" }];
            }

            return obj_formatted;
        })
    }    

    return (
        <DashboardLayout
            headerTitle={"User Logging"}

            bodyClassName={"logging"}
            body={(
                <GeneralTable
                    className={"logging-table"}
                    columns={loggingColumns.getColumns()}
                    data={logList_formatted}
                    minRows={10}

                    getTableData={props.getList}

                    outerTableHeader={() => {
                        return (
                            <div className={"logging-table-header "}>
                                <div className={"logging-tableHeader-title tableHeaderTitle "}>
                                    Log List
                                </div>
                            </div>
                        );
                    }}

                    isTableDataLoading={getLogs_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(logListHeaders)}

                    isCheckboxRequired isCheckboxColumnFirst
                    isExpanderRequired isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}